import React, {useMemo} from 'react';
import {useNavigate} from 'react-router-dom';

import {addComma} from '@/utils';
import {CurationItem} from '@/store';
import useLogger, {Action} from '@/hooks/useLogger';

import styles from './styles.module.scss';

interface Props {
  item: CurationItem;
}

export default function KnewBrand({item}: Props) {
  const navigator = useNavigate();
  const parser = new DOMParser();
  const sender = useLogger();

  const product = useMemo(() => {
    return item.product;
  }, [item]);
  const magazine = useMemo(() => {
    return item.magazine;
  }, [item]);
  const parsed = parser.parseFromString(magazine?.contents || '', 'text/html');

  return (
    <div className={styles.wrapper}>
      {/* 매거진 */}
      <div
        className={styles.card}
        onClick={() => {
          sender({
            _msg: 'cuMain_' + magazine?.id,
            _screen: window.location.pathname,
            _action: Action.CLICK,
          });
          navigator(
            `/${
              magazine?.category === 'brands'
                ? 'knewbrands'
                : magazine?.category
            }/${magazine?.id}`,
            {
              state: {
                prev: 'home',
              },
            },
          );
        }}>
        <div className={styles.imgWrapper}>
          <img src={magazine?.imageUrl} />
        </div>
        <div className={styles.contents_title_wrapper}>
          <span className={styles.title}>{magazine?.title}</span>
          <span className={`${styles.icon} stick-arrow-right-icon`}>
            &nbsp;
          </span>
        </div>
        <div className={styles.contents}>
          {parsed.getElementById('for-contents')?.textContent || ''}
        </div>
      </div>
      {/* 컬렉션 */}
      <div
        className={styles.list}
        onClick={() => {
          sender({
            _msg: 'cuPopup_' + magazine?.id,
            _screen: window.location.pathname,
            _action: Action.CLICK,
          });
          navigator(
            `/${product?.category === 'popup' ? 'popup' : 'zip'}/${
              product?.id
            }`,
            {
              state: {
                prev: 'home',
              },
            },
          );
        }}>
        <div className={styles.imgWrapper}>
          <img src={product?.imageUrl} />
        </div>
        <div className={styles.txtWrapper}>
          <div className={styles.collectionTitle}>{product?.title}</div>
          <div className={styles.collectionSubTitle}>{product?.subtitle}</div>
          <div className={styles.price}>
            {!!product?.discountNumber && product?.discountNumber > 0 && (
              <span>{`${product?.discountNumber}%`}</span>
            )}
            {addComma(Number(product?.price))}
          </div>
        </div>
      </div>
    </div>
  );
}
